import axios from 'axios';
import store from '../vuex/store'
import Vue from 'vue';
import routes from '../routes'
import router from '../router'
import { Notification, MessageBox, Message, Loading } from 'element-ui'

// 全局错误弹框去重：短时间内相同内容只显示一次
let _lastErrorMessage = null;
let _lastErrorTime = 0;
function showErrorOnce(msg) {
  var now = Date.now();
  // 3 秒内相同内容不再重复弹出
  if (msg === _lastErrorMessage && now - _lastErrorTime < 3000) {
    return;
  }
  _lastErrorMessage = msg;
  _lastErrorTime = now;
  Message({ message: msg, type: 'error' });
}

// 创建 Axios 实例
const service = axios.create({
  //baseURL: '/prod-api/', //本地
  baseURL: 'https://api.unishow.live/', //线上
  //baseURL: 'https://test.unishow.live/prod-api/', //测试
  timeout: 10000, // 请求超时时间
  withCredentials: true
});
// 请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = store.state.token;
	const language = localStorage.getItem('Language');
    if (token) {
      config.headers['unishow_api_token'] = token;
    }
	const langMap = {
      'cn': 'chinese',
      'en': 'english',
      'tw': 'taiwan',
      'ja': 'japanese',
      'ko': 'korean'
    };
	config.headers['language'] = language ? (langMap[language] || 'taiwan') : 'taiwan';
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  function (response) {
    // 对响应数据做些什么
    const res = response.data;
	console.log(res,123)
	if (res.code == 200) {
	  return res;
	}else if (res.code == 500) {
      // 处理业务错误
      showErrorOnce(res.msg)
	  return Promise.reject(res); // 抛出业务错误
    }else if (res.code == 401) {
      // 处理业务错误
      showErrorOnce(res.msg)
	  // router.push('/login');
	  setTimeout(v=>{
		sessionStorage.setItem('user', 1);
		window.location.href = '#/login'; 
	  },1000)
	  return Promise.reject(res); // 抛出业务错误
    } else {
      showErrorOnce(res.msg)
	  return Promise.reject(res); // 抛出业务错误
    }
  }.bind(new Vue()),
  (error) => {
    // 对响应错误做些什么
    return Promise.reject(error);
  }
);

export default service;


// WEBPACK FOOTER //
// ./src/utils/request.js